module.exports = __webpack_public_path__ + "static/P1-North-Hobart-a15d9345d0f9a16c54af61c747a1faee.jpeg";